import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import PlacesTable from 'components/place/PlacesTable'

export const Route = createFileRoute('/_auth/_admin/admin/places')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack gap="xl" mt="xl">
      <PlacesTable />
    </Stack>
  )
}
